import { GEOIP_FAILURE, GEOIP_FALLBACK, GEOIP_REQUEST, GEOIP_SUCCESS } from "./geoip-action-types";
import { getLocationFromIP } from "./geoip-services";

const geoIpRequest = () => ({
    type: GEOIP_REQUEST
});

const geoIpSuccess = (locationData) => ({
    type: GEOIP_SUCCESS,
    response: locationData
});

const geoIpFailure = (errorObj) => ({
    type: GEOIP_FAILURE,
    error: errorObj
});

const geoIpFallback = (country) => ({
    type: GEOIP_FALLBACK,
    response: { country }
});

const fetchGeoIp = () => async (dispatch) => {
    dispatch(geoIpRequest);
    try {
        const locationData = await getLocationFromIP();
        dispatch(geoIpSuccess(locationData));
    } catch (err) {
        dispatch(geoIpFailure(err));
        if (window && window.gdpr) {
            dispatch(geoIpFallback(window.gdpr.country_code));
        }
    }
};

export default {
    fetchGeoIp,
    geoIpRequest,
    geoIpSuccess,
    geoIpFailure,
    geoIpFallback
};
